module.exports = __webpack_public_path__ + "img/earth.3351fd9b.png";